/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Skip_Reason_Merged_Into_Other_OrderInputs */

const vi_einvoice_skip_reason_merged_into_other_order = /** @type {(inputs: Einvoice_Skip_Reason_Merged_Into_Other_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gộp vào đơn khác`)
};

/**

* @param {Einvoice_Skip_Reason_Merged_Into_Other_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_skip_reason_merged_into_other_order = /** @type {((inputs?: Einvoice_Skip_Reason_Merged_Into_Other_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Skip_Reason_Merged_Into_Other_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_skip_reason_merged_into_other_order(inputs)
});